export default "__VITE_ASSET__BhSEuBOs__"